import Hero from '@organisms/Hero/Hero';
import Sections from '@organisms/Sections/Sections';
import { LandingPage } from '@type-declarations/page';

function LandingTemplate({ page }: { page: LandingPage }) {
  const { title, introText, image, alignment, cta, videoDesktop, videoMobile } =
    page;

  return (
    <div data-theme={page.theme}>
      <Hero
        title={title}
        text={introText}
        image={image}
        video={{
          mobile: videoMobile,
          desktop: videoDesktop,
        }}
        variant="large"
        cta={cta}
        alignment={alignment}
      />

      <div className="u-mt-12@from-lg">
        <Sections sections={page.sections} />
      </div>
    </div>
  );
}

export default LandingTemplate;
